<template>
  <div class="setComponent">
    <!-- 表单 -->
    <el-form :model="ruleForm" ref="ruleForm" class="form-setting" size="medium">
      <el-form-item :label="$i18n.t('wm_lang_812d1b')" prop="saveSent">
        <el-switch v-model="ruleForm.saveSent"  :disabled="!saveSentPriv" @change="changeSaveSent"></el-switch><span v-if="!saveSentPriv" class="f12 c_red ml5">{{$t("wm_lang_html_e0f673")}}</span>
        <p class="f12 c_blue">{{$t("wm_lang_html_126fc3")}}OutLook/Foxmail{{$t("wm_lang_html_3c8045")}}IMAP{{$t("wm_lang_html_bdc07d")}}</p>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_fec2b4')" prop="authCode">
        <el-switch v-model="ruleForm.authCode" @change="changeAuthCode"></el-switch>
        <p class="f12 c_blue">{{$t("wm_lang_html_9439fa")}}</p>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getAuthCode" v-show="ruleForm.authCode">{{$t("wm_lang_html_e7d4e2")}}</el-button>
      </el-form-item>
      <!-- 表格 -->
      <el-form-item v-show="ruleForm.authCode && tableData.length > 0">
      <el-table
        size="medium"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          :label="$i18n.t('wm_lang_f3b7af')">
          <template slot-scope="scope">
            <span>{{ scope.row.memo }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$i18n.t('wm_lang_696f5a')">
          <template slot-scope="scope">
            <span>{{ $moment(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$i18n.t('wm_lang_002a67')">
          <template slot-scope="scope">
            <span>{{ scope.row.recentlyUseTime ? $moment(scope.row.recentlyUseTime).format('YYYY-MM-DD HH:mm:ss') : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$i18n.t('wm_lang_7354e6')+'IP'">
          <template slot-scope="scope">
            <span>{{ scope.row.recentlyUseIp ? scope.row.recentlyUseIp : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$i18n.t('wm_lang_2b6bc0')"
          width="160">
          <template slot-scope="scope">
            <el-link type="danger" :underline="false" @click="deleteAuthCode(scope.row.authCodeId)">{{$t("wm_lang_html_2f4aad")}}</el-link>
          </template>
        </el-table-column>
      </el-table>
      </el-form-item>
    </el-form>
    <br><br>
    <!-- 添加授权码模态框 -->
    <el-dialog :title="$i18n.t('wm_lang_01efad')" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="36%">
      <el-form :model="codeForm" :rules="rules" ref="codeForm" class="form-setting gsForm">
        <el-form-item :label="$i18n.t('wm_lang_9ad8d3')" :label-width="formLabelWidth">
          <p class="flexCenter"><span class="cutout max197 mr10">{{codeForm.passwd}}</span><el-button @click="copyCode(codeForm.passwd)" size="mini" type="primary">{{$t("wm_lang_html_79d3ab")}}</el-button></p>
          <p class="c_note f12">{{$t("wm_lang_html_a675fc")}}</p>
        </el-form-item>
        <el-form-item :label="$i18n.t('wm_lang_f3b7af')" prop="memo" :label-width="formLabelWidth">
          <el-input v-model="codeForm.memo" autocomplete="off" :placeholder="$i18n.t('wm_lang_cc2644')"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{$t("wm_lang_html_55c3f6")}} {{$t("wm_lang_html_aa4d94")}}</el-button>
        <el-button type="primary" @click="addAuthCode('codeForm')">{{$t("wm_lang_html_2d7a2f")}} {{$t("wm_lang_html_a7a342")}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import xmail from '@/api/api';
import storeLocal from 'store';
import { bitIs1 } from '@/utils/utils';
export default {
  name: 'clientSetting',
  data () {
    const validateMemo = (rule, value, callback) => {
      if (/[@$￥#!%^&'<>"{}\s]/.test(value)) {
        callback(new Error(this.$i18n.t('wm_lang_f857f6')+'@$￥#!%^&\'<>\"{}'+this.$t("wm_lang_html_b4cc1c")));
      } else {
        callback();
      }
    }
    return {
      localConfigSetting: {},
      saveSentPriv: false,
      dialogFormVisible: false,
      formLabelWidth: '80px',
      codeForm: {
        passwd: '',
        memo: ''
      },
      // 表格
      tableData: [],
      // 表单
      ruleForm: {
        saveSent: false,
        authCode: false
      },
      rules: {
        memo: [
          { max: 64, message: this.$i18n.t('wm_lang_379b24')+'64'+this.$i18n.t('wm_lang_15d410'), trigger: 'blur' },
          { trigger: 'blur', validator: validateMemo }
        ]
      }
    }
  },
  mounted() {
    this.localConfigSetting = storeLocal.get('Pwm-configSetting');
    this.saveSentPriv = bitIs1(this.localConfigSetting.priviage.priviage1, 9);

    let self = this;
    (function (api, enums, pms) {
      api.ClientSetting.queryClientSetting({}, function (res) {
        if(res.data.code === 0) {
          console.log(res.data.data);
          self.ruleForm.saveSent = res.data.data.sendMailEnble;
          self.ruleForm.authCode = res.data.data.authCodeEnble;
          if(!self.saveSentPriv) { //如果ma禁用了此功能则关闭
            self.ruleForm.saveSent = false;
          }
        }
      })
    })(xmail.api, xmail.enums, xmail.pms);
    this.viewCodeList();
  },
  methods: {
    getAuthCode() {
      if(this.tableData.length >= 20) {
        this.$message({
          type: 'warning',
          message: this.$i18n.t('wm_lang_22c795')+'20'+this.$i18n.t('wm_lang_cc1bac')
        })
        return;
      }
      this.codeForm.memo = '';
      this.dialogFormVisible = true;
      if(this.$refs['codeForm']) {
        this.$refs['codeForm'].resetFields();
      }
      let self = this;
      (function (api, enums, pms) {
        api.ClientSetting.getAuthCode({}, function (res) {
          if(res.data.code === 0) {
            self.codeForm.passwd = res.data.data.passwd;
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    addAuthCode(formName) {
      if(!this.codeForm.memo) {
        this.$message({
          type: 'warning',
          message: this.$i18n.t('wm_lang_243e1d')
        })
        return;
      }
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          let self = this;
          (function (api, enums, pms) {
            let pm = pms.ClientSetting.addAuthCodeParamBuilder();
            pm.languageType = enums.LanguageType.cn;
            pm.memo = self.codeForm.memo;
            pm.passwd = self.codeForm.passwd
            // pm.passwdType = enums.PasswdType;
            api.ClientSetting.addAuthCode(pm, function (res) {
              if(res.data.code === 0) {
                self.dialogFormVisible = false;
                self.$message({
                  type: 'success',
                  message: self.$i18n.t('wm_lang_a5bfd7')
                });
                self.viewCodeList();
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
        }
      });
    },
    deleteAuthCode(id) {
      this.$confirm(this.$i18n.t('wm_lang_312df5'), this.$i18n.t('wm_lang_c45357'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
        cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        let self = this;
        (function (api, enums, pms) {
          let pm = pms.ClientSetting.delAuthCodeParamBuilder();
          pm.authCodeId = id;
          api.ClientSetting.delAuthCode(pm, function (res) {
            if(res.data.code === 0) {
              self.dialogFormVisible = false;
              self.$message({
                type: 'success',
                message: self.$i18n.t('wm_lang_0007d1')
              });
              self.viewCodeList();
            }
          })
        })(xmail.api, xmail.enums, xmail.pms);
      }).catch(action => {
        //
      });
    },
    copyCode(data) {
      let url = data;
      let oInput = document.createElement('input');
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: this.$i18n.t('wm_lang_20a495'),
        type: 'success'
      });
      oInput.remove()
    },
    changeSaveSent() {
      if(!this.saveSentPriv) {
        this.$message({
          message: this.$i18n.t('wm_lang_28ee2b'),
          type: 'warning'
        });
        return;
      }
      let self = this;
      (function (api, enums, pms) {
        let pm = pms.ClientSetting.saveSendMailEnbleParamBuilder();
        pm.mailEnble = self.ruleForm.saveSent;
        pm.saveClientLetter = self.saveSentPriv;
        api.ClientSetting.saveSendMailEnble(pm, function (res) {
          if(res.data.code === 0) {
            console.log(res.data.data);
            self.$message({
              type: 'success',
              message: self.$i18n.t('wm_lang_3b1083')
            })
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    changeAuthCode() {
      if(this.ruleForm.authCode) {
        this.$confirm(this.$i18n.t('wm_lang_35a2b9')+'"'+this.$i18n.t('wm_lang_1c8ac2'), this.$i18n.t('wm_lang_c45357'), {
          confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
          cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          let self = this;
          (function (api, enums, pms) {
            let pm = pms.ClientSetting.saveAuthCodeEnableParamBuilder();
            pm.authCodeEnble = self.ruleForm.authCode;
            pm.languageType = enums.LanguageType.cn;
            api.ClientSetting.saveAuthCodeEnable(pm, function (res) {
              if(res.data.code === 0) {
                // pop那可能调不通 还没跟C那面调
                console.log(res.data.data);
                self.$message({
                  type: 'success',
                  message: self.$i18n.t('wm_lang_3b1083')
                })
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
        }).catch(() => {
          this.ruleForm.authCode = !this.ruleForm.authCode
        });
      } else {
        this.$confirm(this.$i18n.t('wm_lang_b2f801')+'"'+this.$i18n.t('wm_lang_e2cd2e'), this.$i18n.t('wm_lang_c45357'), {
          confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
          cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          let self = this;
          (function (api, enums, pms) {
            let pm = pms.ClientSetting.saveAuthCodeEnableParamBuilder();
            pm.authCodeEnble = self.ruleForm.authCode;
            pm.languageType = enums.LanguageType.cn;
            api.ClientSetting.saveAuthCodeEnable(pm, function (res) {
              if(res.data.code === 0) {
                console.log(res.data.data);
                self.viewCodeList();
                self.$message({
                  type: 'success',
                  message: self.$i18n.t('wm_lang_3b1083')
                })
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
        }).catch(() => {
          this.ruleForm.authCode = !this.ruleForm.authCode
        });
      }
    },
    viewCodeList() {
      let self = this;
      (function (api, enums, pms) {
        api.ClientSetting.queryAuthCodeInfo({}, function (res) {
          if(res.data.code === 0) {
            console.log(res.data.data);
            self.tableData = res.data.data;
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .setComponent{padding:10px;}
 .setComponent .title .el-divider--horizontal{margin:10px 0;}
 .c_note{ color:#F56C6C ; line-height:14px;}
 .copy_btn{ margin-left: 200px}
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/clientSetting.vue